import { render, staticRenderFns } from "./EventView.vue?vue&type=template&id=e109c4f4&scoped=true&class=events-view-bg&data-app=true"
import script from "./EventView.vue?vue&type=script&lang=js"
export * from "./EventView.vue?vue&type=script&lang=js"
import style0 from "./EventView.vue?vue&type=style&index=0&id=e109c4f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e109c4f4",
  null
  
)

export default component.exports